import DashView from './components/Dash.vue'
import LoginView from './components/Login.vue'
import LogoutView from './components/Logout.vue'
import NotFoundView from './components/404.vue'

// Import Views - Dash
import DashboardView from './components/views/Dashboard.vue'
import UsuarioView from './components/views/Usuario.vue'
import ManutencaoView from './components/views/Manutencao.vue'
import GraficosGeraisView from './components/views/GraficosGerais.vue'
import GraficosGeraracaoView from './components/views/GraficosGeracao.vue'
import GraficosEficienciaView from './components/views/GraficosEficiencia.vue'
import GraficosMaterialView from './components/views/GraficosMaterial.vue'
import GraficosAcumuladosView from './components/views/GraficosAcumulados.vue'

// Routes
const routes = [
  {
    path: '/login',
    component: LoginView
  },
  {
    path: '/logout',
    component: LogoutView
  },
  {
    path: '/',
    component: DashView,
    children: [
      {
        path: 'dashboard',
        alias: '',
        component: DashboardView,
        name: 'Principal',
        meta: {
          namePtBr: 'Principal',
          nameEs: 'Principal',
          nameEn: 'Home',
          nameDe: 'Hauptsächlich',
          descriptionPtBr: 'Monitoramento do Biodigestor',
          descriptionEs: 'Monitoreo de biodigestores',
          descriptionEn: 'Biodigester Monitoring',
          descriptionDe: 'Biodigester-Überwachung',
          requiresAuth: true
        }
      },
      {
        path: 'usuario',
        alias: '',
        component: UsuarioView,
        name: 'Usuário',
        meta: {
          namePtBr: 'Usuário',
          nameEs: 'Usuario',
          nameEn: 'User',
          nameDe: 'Nutzer',
          descriptionPtBr: 'Edição dos dados de Usuário',
          descriptionEs: 'Editar datos de usuario',
          descriptionEn: 'Editing User Data',
          descriptionDe: 'Benutzerdaten bearbeiten',
          requiresAuth: true
        }
      },
      {
        path: 'manutencao',
        alias: '',
        component: ManutencaoView,
        name: 'Manutenção',
        meta: {
          namePtBr: 'Manutenção',
          nameEs: 'Mantenimiento',
          nameEn: 'Maintenance',
          nameDe: 'Wartung',
          descriptionPtBr: 'Monitoramento de todas variáveis do Biodigestor',
          descriptionEs: 'Seguimiento de todas las variables del biodigestor',
          descriptionEn: 'Monitoring of all Biodigester variables',
          descriptionDe: 'Überwachung aller Biodigester-Variablen',
          requiresAuth: true
        }
      },
      {
        path: 'graficos-acumulados',
        alias: '',
        component: GraficosAcumuladosView,
        name: 'Gráficos Acumulados',
        meta: {
          namePtBr: 'Gráficos Acumulados',
          nameEs: 'Gráficos acumulados',
          nameEn: 'Accumulated Charts',
          nameDe: 'Akkumulierte Charts',
          descriptionPtBr: 'Relatório dos valores acumulados',
          descriptionEs: 'Informe de valores acumulados',
          descriptionEn: 'Accumulated Values ​​Report',
          descriptionDe: 'Bericht der kumulierten Werte',
          requiresAuth: true
        }
      },
      {
        path: 'graficos-gerais',
        alias: '',
        component: GraficosGeraisView,
        name: 'Gráficos Gerais',
        meta: {
          namePtBr: 'Gráficos Gerais',
          nameEs: 'Gráficos generales',
          nameEn: 'General Graphics',
          nameDe: 'Allgemeine Grafiken',
          descriptionPtBr: 'Relatório das variáveis não acumuladas do Biodigestor',
          descriptionEs: 'Informe de variables no acumuladas del biodigestor',
          descriptionEn: 'Biodigester non-accumulated variables report',
          descriptionDe: 'Bericht zu nicht akkumulierten Variablen des Biodigesters',
          requiresAuth: true
        }
      },
      {
        path: 'graficos-geracao',
        alias: '',
        component: GraficosGeraracaoView,
        name: 'Gráficos Geração Energia',
        meta: {
          namePtBr: 'Gráficos de Geração de Energia',
          nameEs: 'Gráficos de generación de energía',
          nameEn: 'Power Generation Charts',
          nameDe: 'Diagramme zur Stromerzeugung',
          descriptionPtBr: 'Valores de energia coletados no gerador.',
          descriptionEs: 'Valores de energía recogidos del generador y registrados.',
          descriptionEn: 'Energy values ​​collected from the generator and recorded.',
          descriptionDe: 'Vom Generator gesammelte und aufgezeichnete Energiewerte.',
          requiresAuth: true
        }
      },
      {
        path: 'graficos-eficiencia',
        alias: '',
        component: GraficosEficienciaView,
        name: 'Gráficos de Eficiência',
        meta: {
          namePtBr: 'Gráficos de Eficiência',
          nameEs: 'Gráficos de eficiencia',
          nameEn: 'Efficiency Charts',
          nameDe: 'Effizienzdiagramme',
          descriptionPtBr: 'Valores de energia coletados no gerador.',
          descriptionEs: 'Valores de energía recogidos del generador y registrados.',
          descriptionEn: 'Energy values ​​collected from the generator and recorded.',
          descriptionDe: 'Vom Generator gesammelte und aufgezeichnete Energiewerte.',
          requiresAuth: true
        }
      },
      {
        path: 'graficos-material',
        alias: '',
        component: GraficosMaterialView,
        name: 'Gráficos Material',
        meta: {
          namePtBr: 'Gráficos Material',
          nameEs: 'Gráficos de materiales',
          nameEn: 'Material Graphics',
          nameDe: 'Materialgrafiken',
          descriptionPtBr: 'Valores registrados da análise do material do biodigestor',
          descriptionEs: 'Valores registrados a partir del análisis del material biodigestor',
          descriptionEn: 'Values ​​recorded from the analysis of the biodigester material',
          descriptionDe: 'Erfasste Werte aus der Analyse des Biovergärungsmaterials',
          requiresAuth: true
        }
      }
    ]
  },
  {
    // not found handler
    path: '*',
    component: NotFoundView
  }
]

export default routes



// WEBPACK FOOTER //
// ./src/routes.js